import React from 'react'
import styled from 'styled-components'

export type BgShapesVariant =
  | 'bottom-section-wave'
  | 'form-section'
  | 'form-section-short'

type Props = {
  bgColor?: string
  variant: BgShapesVariant
  className?: string
}

export const BgShapes = ({
  bgColor,
  variant,
  className,
  children,
}: WithChildren<Props>): JSX.Element => {
  return (
    <Wrapper bgColor={bgColor}>
      {variant === 'bottom-section-wave' ? (
        <svg viewBox='0 0 1440 295' className={className}>
          <path d='M537.813 198c331.885-10.71 695.217 8.95 902.187 97V0H0v184.5C289.399 217 537.813 198 537.813 198z' />
        </svg>
      ) : variant === 'form-section' ? (
        <>
          <svg viewBox='0 0 1440 87'>
            <path d='M-469.206 636.081C-532.93 349.926 -344.714 213.683 -211.222 154.257C290.961 -69.297 934.419 158.496 1399.18 14.8147C1529.17 -25.3719 1718.16 -176.292 2117.64 -78.7134C2517.12 18.8648 2482.62 497.983 2301.63 704.629C2120.64 911.276 1778.16 1033.49 1543.17 1054.43C1308.19 1075.36 1133.96 997.487 598.937 997.487C63.9188 997.487 -363.596 1110.33 -469.206 636.081Z' />
          </svg>
          <InnerWrapper bgColor={bgColor}>{children}</InnerWrapper>
          <svg viewBox='0 0 1440 61'>
            <path d='M-469.206 -360.919C-532.93 -647.074 -344.714 -783.317 -211.222 -842.743C290.961 -1066.3 934.419 -838.504 1399.18 -982.185C1529.17 -1022.37 1718.16 -1173.29 2117.64 -1075.71C2517.12 -978.135 2482.62 -499.017 2301.63 -292.371C2120.64 -85.7244 1778.16 36.4922 1543.17 57.4264C1308.19 78.3606 1133.96 0.487305 598.937 0.487305C63.9188 0.487305 -363.596 113.33 -469.206 -360.919Z' />
          </svg>
        </>
      ) : variant === 'form-section-short' ? (
        <>
          <svg viewBox='0 0 1440 87'>
            <path d='M1409.75 335.504c-307.18 90.773-673.981 3.001-1210.89 30.915C-338.05 394.334-396.679 103.588-85 55.5c311.68-48.088 740.5 44.5 1269-24s532.93 213.23 225.75 304.004Z' />
          </svg>
          <InnerWrapper bgColor={bgColor}>{children}</InnerWrapper>
          <svg viewBox='0 0 1440 62'>
            <path d='M1408.75 13.504c-307.18 90.773-673.981 3-1210.89 30.915C-339.05 72.334-397.679-218.412-86-266.5c311.68-48.088 740.5 44.5 1269-24s532.93 213.23 225.75 304.004Z' />
          </svg>
        </>
      ) : (
        <></>
      )}
    </Wrapper>
  )
}

type WrapperProps = Pick<Props, 'bgColor'>

const Wrapper = styled.div<WrapperProps>`
  svg {
    display: block;
    path {
      fill: ${({ bgColor }) => bgColor};
    }
  }
`
type InnerWrapperProps = Pick<Props, 'bgColor'>

const InnerWrapper = styled.div<InnerWrapperProps>`
  background-color: ${({ bgColor }) => bgColor};
  overflow: auto; //Fix collapsing margins https://www.w3.org/TR/css-box-3/#collapsing-margins
`
